import React, { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from 'components';
import { useOrderContext } from 'hooks';
import { TranslationNamespace } from 'i18n';
import { DefaultUploadReceiptDialog } from 'views/DefaultOrderView/components/DefaultUploadReceiptDialog';

export const DefaultCustomerPaidReceipts: React.FC = () => {
  const { t: tUploadReceipt } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.upload_confirmation_receipt',
  });

  const {
    receiptsResult: {
      uploadReceiptModalOpen,
      setUploadReceiptModalOpen: onUploadReceiptModalOpen,
      uppy,
      setReceiptUploadCallbacks,
    },
    onConfirmPayment,
  } = useOrderContext();

  useEffect(() => {
    setReceiptUploadCallbacks(onConfirmPayment, () =>
      onUploadReceiptModalOpen(false),
    );
  }, [onConfirmPayment, setReceiptUploadCallbacks, onUploadReceiptModalOpen]);

  return (
    <Fragment>
      {!uploadReceiptModalOpen && (
        <Button
          className="tw-max-w-md tw-max-h-16 tw-mb-4"
          color="success"
          onClick={() => onUploadReceiptModalOpen(true)}
        >
          {tUploadReceipt('upload')}
        </Button>
      )}
      <DefaultUploadReceiptDialog
        open={uploadReceiptModalOpen}
        uppy={uppy}
        onClose={() => onUploadReceiptModalOpen(false)}
      />
    </Fragment>
  );
};
